import FamilyForm from 'app/src/features/UserInfo/components/FamilyForm'
import { UserFamilyMembersTable } from 'app/src/features/UserInfo/components/UserFamilyMembersTable'
import type { membershipApi } from 'app/src/services/welfareportal'
import { getFromSessionStorage } from 'app/src/shared/helpers'
import { Button } from 'primereact/button'
import { Card } from 'primereact/card'
import { useState, type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export function UserFamilyMembersSection(props: { userInfo: membershipApi.MembershipExtended }): ReactElement {
  const { t } = useTranslation('userInfo', { keyPrefix: 'UserInfo.FamilyMembersSection' })
  const [showFamilyForm, setShowFamilyForm] = useState<boolean>(false)
  const campaignStorage = getFromSessionStorage('selectedCampaign') ?? '{}'

  return (
    <div className='grid grid-cols-1'>
      <Card
        className='flex-1'
        title={t('Title')}
        footer={
          JSON.parse(campaignStorage)?.active ? (
            <div className='text-right'>
              <Button rounded onClick={() => setShowFamilyForm(true)}>
                {t('ButtonLabel')}
              </Button>
              {showFamilyForm && (
                <FamilyForm
                  membership={props.userInfo}
                  callbackOnFamilyFormHide={() => setShowFamilyForm(false)}
                  isEdit={false}
                />
              )}
            </div>
          ) : undefined
        }
      >
        <UserFamilyMembersTable userInfo={props.userInfo} />
      </Card>
    </div>
  )
}
